export default __webpack_public_path__ + "static/media/burger-3-735w.f73d3b37.png";